<template>
	<div class="container">
		<div class="error-content">
			<img src="../assets/404.png" alt="" />
			<!-- 页面走丢了～ -->
			<div class="error-text">{{ $t("error.pageNotFound") }}</div>
		</div>
		<van-button type="primary" @click="goBack" block round class="go-back" color="linear-gradient(to right, #ff6034, #ee0a24)">{{ $t("error.goBack") }}</van-button>
	</div>
</template>

<script>
export default {
	name: "ErrorView",
	methods: {
		goBack() {
			this.$router.replace("/");
		},
	},
};
</script>

<style scoped lang="scss">
.container {
	width: 100%;
	// height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	max-width: var(--maxWidth);
	margin: 0 auto;

	.error-content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: calc(40vh - 100px);
		img {
			width: 100px;
			height: 100px;
		}
		.error-text {
			margin-top: 20px;
			font-size: 16px;
		}
	}
	.go-back {
		margin-top: 100px;
		width: 80%;
	}
}
</style>
